import React from 'react'
import BaseDateRangedReport from './BaseDateRangedReport'

export default () => <BaseDateRangedReport
  reportHeader = "Liability Report"
  reportDownloadName = "liabilityReport"
  apiReportName = "liabilityReport"
  rightAlignColumns = {["TOTAL"]}
/>
